var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from "react-dom";
import SeatMap from "./SeatMap";
var browserUpdate = require('browser-update');
browserUpdate({ required: { e: -6, f: -6, o: -6, s: -4, c: -6, text: {
            'msg': 'Ticket purchasing in {brow_name} is unsupported. Please open a recent version of another major browser like Chrome, Firefox, Safari, or Edge',
            'msgmore': '',
            no_permanent_hide: true,
        } }, insecure: true, api: 2021.02 });
import store from "./store";
import './i18n';
import { Provider } from "react-redux";
ReactDOM.render(_jsx(Provider, __assign({ store: store }, { children: _jsx(SeatMap, {}) })), document.getElementById("root"));
